import React, {Component} from 'react';
import {connect} from 'react-redux';
import {actions, Control, Form, track} from 'react-redux-form';
import classnames from 'classnames';
import {Checkbox, Col, ControlLabel, FormControl, FormGroup, Glyphicon, OverlayTrigger, Panel, Row, Tooltip} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import Truncate from 'react-truncate';
import Can from '../common/guards/can';
import ArrowButton from '../common/button-arrow';
import {MODULE_LEVEL} from '../../data/modules';
import Module from '../common/module';
import t from '../../data/translations';
import { tradeSiteDisabled } from '../../utils/toggles';
import rewardStoreImage from '../../assets/img/store_rewards_100.png';
import storeImage from '../../assets/img/store_100.jpg';

class Store extends Component {
  handleSubmit = () => {
  };
  handleVoucherChange = (event) => {
    this.setState({
      voucher: event.target.value
    });
  };
  handleRedeemChange = (model, value) => {
    this.setState({
      autoRedeem: value,
    });
    return (dispatch) => {
      dispatch(actions.change(model, value));
    };
  };
  renderVoucherDenoms = () => {
    const voucher = this.props.vouchers.find(v => v.id === this.state.voucher);
    if (voucher) {
      return [(
        <option key="0" value="" disabled>
          &lt;none&gt;
        </option>
      )].concat(voucher.denominations.map(denom => (
        <option
          key={denom.id}
          value={denom.id}
        >
          {denom.variant}
        </option>
      )));
    }
    return [];
  };

  constructor(props) {
    super(props);

    const reward = props.outlet.attributes['reward-details'] || [];

    this.state = {
      voucher: reward['voucher-type'] ? reward['voucher-type'].id : undefined,
      autoRedeem: reward['auto-redeem'],
    };
  }

  render() {
    const {
      outlet, registration, vouchers, autoRedeem
    } = this.props;

    const {reward, name, level} = outlet.attributes;

    const details = `/store-details/${outlet.id}`;
    const panelFooter = (
      <div>
        {
          outlet.attributes['num-of-staff'] > 0 && (
            <Can subjectClass="staff_rewards" action="handle">
              <p>
                No. staff
                <span className="staff-number">
                  {outlet.attributes['num-of-staff'] || 0}
                </span>
              </p>
            </Can>
          )}
        {
          registration.pending && !registration.internal && reward && (
            <Can subjectClass="staff_rewards" action="handle">
              <Form
                className="reward-form"
                model={track('deep.store_summary[]', store => store.id === outlet.id)}
                onSubmit={this.handleSubmit}
              >
                <Row>
                  <Col className="reward-dist" lg={5}>
                    Personal Rewards
                  </Col>
                  <Col className="reward-dist" lg={5}>
                    { t('staffRewards') }
                  </Col>
                  <Col className="ta-right" lg={2}>
                    <OverlayTrigger
                      overlay={(
                        <Tooltip className="tooltip grey" id="tooltip">
                          Currently, the points this store earns will be split as indicated below.
                          To amend this, please contact us once you have completed registration.
                        </Tooltip>
                      )}
                      placement="right"
                    >
                      <Glyphicon glyph="info-sign"/>
                    </OverlayTrigger>
                  </Col>
                </Row>
                <Row>
                  <Col className="reward-dist personal" lg={5}>
                    {outlet.attributes['reward-details']['reward-markup'] || 0}
                    %
                  </Col>
                  <Col className="reward-dist staff" lg={5}>
                    {100 - (outlet.attributes['reward-details']['reward-markup'] || 0)}
                    %
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <FormGroup controlId="voucherType">
                      <ControlLabel>
                        I would like to reward my staff with the following vouchers...
                      </ControlLabel>
                      <Control.select
                        component={FormControl}
                        componentClass="select"
                        model=".voucher_type_id"
                        onChange={this.handleVoucherChange}
                      >
                        <option value="" disabled>
                          &lt;none&gt;
                        </option>
                        {
                          vouchers.map(voucher => (
                            <option
                              key={voucher.id}
                              value={voucher.id}
                            >
                              {voucher.name}
                            </option>
                          ))
                        }
                      </Control.select>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <Control.checkbox
                      changeAction={this.handleRedeemChange}
                      component={Checkbox}
                      model=".auto_redeem"
                    >
                      { t('staffRewards.autoRedeem') }
                    </Control.checkbox>
                  </Col>
                </Row>

                <Row>
                  <Col className="auto-redeem" lg={12}>
                    {
                      autoRedeem && (
                        <FormGroup controlId="voucherDenomination">
                          <ControlLabel>
                            { t('staffRewards.denomination') }
                          </ControlLabel>
                          <Control.select
                            component={FormControl}
                            componentClass="select"
                            model=".voucher_denomination_id"
                          >
                            {
                              this.state.voucher &&
                              this.renderVoucherDenoms()
                            }
                          </Control.select>
                        </FormGroup>
                      )}
                  </Col>
                </Row>
              </Form>
            </Can>
          )}
        {
          !registration.pending && outlet.attributes['customer-number'] && (
            <div>
              <Link to={details}>
                <ArrowButton
                  className="btn-block"
                  color="red"
                  submit={false}
                >
                  Details
                </ArrowButton>
              </Link>
            </div>
          )}
        {!outlet.attributes['customer-number'] && (
          <div>
            Awaiting approval
            <OverlayTrigger
              overlay={(
                <Tooltip className="tooltip grey" id="tooltip">
                  Please note this store will not be linked to your Ignite
                  account until it has been verified by Imperial Tobacco
                </Tooltip>
              )}
              placement="bottom"
            >
              <Glyphicon glyph="info-sign" className="pull-right"/>
            </OverlayTrigger>
          </div>
        )}
        {(tradeSiteDisabled() || outlet.attributes.reward) && (
          <Module name={MODULE_LEVEL}>
            <div className="text-center">
              {level && (
                <span>
                  Store level:
                  {' '}{level}
                </span>
              )}
            </div>
          </Module>
        )}
      </div>
    );
    return (
      <Col sm={12}>
        <img alt="Your rep" className="rep-image user-store" src={reward ? rewardStoreImage : storeImage}/>
        <Panel className="store-item" footer={panelFooter}>
          <div className="store-name">
            <Truncate lines={2}>
              {name.toUpperCase()}
            </Truncate>
          </div>
          {outlet.attributes['customer-number'] && (
            <div className="customer-number padding-b-26">
              Store number {outlet.attributes['customer-number']}
            </div>
          )}
          {(tradeSiteDisabled() || outlet.attributes.reward) && (
            <Module name={MODULE_LEVEL}>
              {level && (
                <span className="customer-number">
                  Store level:
                  <span className="store-name store-level">{' '}{level}</span>
                </span>
              )}
            </Module>
          )}
          {reward && (
            <div className="store-name padding-b-26">
              Reward store
            </div>
          )}
          {!registration.pending && outlet.attributes['customer-number'] && (
            <div>
              <Link to={details} className="store-btn-link padding-b-26">
                View store details
              </Link>
            </div>
          )}
          <div className="user-store">
            {!outlet.attributes['customer-number'] && (
              <span className="store-await">
                Awaiting approval
                <OverlayTrigger
                  overlay={(
                    <Tooltip className="tooltip grey" id="tooltip">
                      Please note this store will not be linked to your Ignite
                      account until it has been verified by Imperial Tobacco
                    </Tooltip>
                  )}
                  placement="right"
                >
                  <span className="tip">?</span>
                </OverlayTrigger>
              </span>
            )}
          </div>
        </Panel>
        <div className={classnames('reward-footer', {'no-reward': !reward})}>
          {reward && (
            <span>
              <Glyphicon glyph="gift"/>
                Reward store
            </span>
          )}
        </div>
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  registration: state.registration
});

export default connect(mapStateToProps)(Store);



// WEBPACK FOOTER //
// ./src/components/store-summary/store.jsx